import React from "react";
/* 

Available alertClass options:

 "alert-danger"  (red, error)
 "alert-warning" (yellow, warning)
 "alert-info"    (blue, info)
 "alert-success"  (green, success)
 "alert-secondary" (gray ,"secondary")

*/

export default function NoDataFound({
    colSpan = 5,
    padding = "20px 0",
    message = "Records not found",
    alertClass = "alert-secondary"
}) {
    return (
        <tr>
            <td
                colSpan={colSpan}
                style={{
                    textAlign: "center",
                    padding,
                    borderBottom: "none",
                    pointerEvents: "none",
                }}
            >
                <div className={`alert ${alertClass} no_data`}>{message}</div>
            </td>
        </tr>
    );
}
